import type { ActionReducer, MetaReducer } from '@ngrx/store';
import { authActions } from './auth.actions';
import { clearNgRxPersistedLocalStorage } from './ngrx-persisted-state.keys';

/** Resets the entire store and clears persisted list/draft state when the user logs out. */
export function clearStateOnLogoutMetaReducer(reducer: ActionReducer<unknown>): ActionReducer<unknown> {
  return (state, action) => {
    if (action.type === authActions.logout.type) {
      clearNgRxPersistedLocalStorage();
      return reducer(undefined, action);
    }
    return reducer(state, action);
  };
}

export const logoutMetaReducers: MetaReducer[] = [clearStateOnLogoutMetaReducer];
